<template>
  <p :class="className">{{text}}</p>
</template>

<script>
export default {
  props: {
    className: Array,
    text: String,
    selected: Number
  }
}
</script>

<style lang="scss" scoped>
</style>
